import React from "react";

/** Wrapping row of action buttons; `right` renders a second group aligned to the end. */
const ActionBar = ({ children, right }) => (
  <div className="appt-actions">
    <div className="appt-actions__group">{children}</div>
    {right && <div className="appt-actions__group appt-actions__group--right">{right}</div>}
  </div>
);

export default ActionBar;
